import * as actionTypes from "./actionTypes";

import api from "../../services";
import messages from "../../constants/messages";
import { apiStart, apiSuccess } from "./apiActions";
import { errorHandler, catchHandler, successHandler } from "./responseHandler";
import { deleteFileFromS3 } from "./physicianOnboardingActions";
import { getUrls } from "./noteTemplateActions";
import moment from "moment";
import {
  parseDateToLocal,
  parseDateToUTC,
  parseTimeToLocal,
  parseTimeToUTC,
} from "../../utils/parseDateTime";

function array_only(arr, condition) {
  let hold_test = [];
  arr.map(function (e, i) {
    if (eval(condition)) {
      hold_test.push(e);
    }
  });
  return hold_test;
}

export const getAllPatientNotes = (id, search = "", page = 1) => {
  return (dispatch, getState) => {
    let patientNotes = getState()?.dashboard?.patients?.allNotes;
    dispatch(apiStart(localStorage.getItem("viewMode")));
    api
      .patientNotesGet(id, search, page)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          const resp = res.data[0];

          let templatesData = [];
          let notes = [];
          templatesData =
            page > 1 ? [...templatesData, ...patientNotes] : templatesData;

          resp.results.forEach(template => {
            let obj = {};
            let notesImages;

            if (template?.notes?.length > 0) {
              notesImages = array_only(
                template?.notes,
                "['.jpeg', '.png', '.jpg'].some(el => (e != null || e != undefined) && e.includes(el))"
              );

              template?.notes.forEach(i => {
                if (
                  (i != null || i != undefined) &&
                  !i.includes(".png", ".jpeg", "jpg")
                ) {
                  notes = i;
                }
              });
            }

            let comment;

            let last_updated;

            if (template?.comment) {
              comment = template?.comment[template?.comment?.length - 1];

              last_updated = `${moment(
                parseDateToLocal(comment?.time_stamp)
              ).format("MMMM DD, YYYY")} • ${parseTimeToLocal(
                moment(comment?.time_stamp).format("HH:mm"),
                moment(comment?.time_stamp).format("YYYY-MM-DD")
              )}`;
            }

            obj = {
              ...template,
              notes,
              notesImages,
              additional_comment: comment?.comment,
              last_updated,
            };

            templatesData.push(obj);
          });

          dispatch({
            type: actionTypes.GET_PATIENT_NOTES,
            payload: templatesData,
            total_pages: resp.links.total_pages,
          });
        } else {
          errorHandler(res.message[0]);
        }

        dispatch(apiSuccess());
      })
      .catch(error => {
        console.log("error: ", error);
        catchHandler(error, dispatch);
      });
  };
};

export const searchPatientNotes = q => {
  return dispatch => {
    dispatch({
      type: actionTypes.SEARCH_PATIENT_NOTES,
      searchValue: q,
      total_pages: 1,
    });
  };
};

export const setCurrentNoteData = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_CURRENT_NOTE_DATA,
      payload,
    });
  };
};

export const clearCurrentNoteData = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.CLEAR_CURRENT_NOTE_DATA,
    });
  };
};

export const setPatientFiles = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_PATIENT_FILES,
      payload,
    });
  };
};

export const editPatientNotes = (pid, lock) => {
  return (dispatch, getState) => {
    const currentData = getState()?.dashboard?.patients?.currentData;

    let comments = [];
    let notesArray = [];

    // if (currentData?.comment) {
    //   comments = [...currentData?.comment];
    // }

    if (currentData?.notesImages) {
      notesArray = [...currentData?.notesImages];
    }

    if (currentData?.notes?.length > 0) {
      notesArray.push(currentData.notes);
    }

    if (currentData?.additional_comment?.length > 0) {
      comments.push({
        comment: currentData.additional_comment,
        time_stamp: `${parseDateToUTC(
          moment().format("YYYY-MM-DD")
        )} ${parseTimeToUTC({
          hour: moment().format("HH"),
          minutes: moment().format("mm"),
        })}`,
      });
    }

    let { id } = currentData;

    const updatedPayload = {
      comment: comments?.length > 0 ? comments : null,
      is_locked: lock,
      note_name: currentData.note_name,
      chief_complaint: currentData.chief_complaint,
      notes: notesArray?.length > 0 ? notesArray : null,
      assessment: currentData.assessment,
      plan: currentData.plan,
    };

    dispatch(apiStart());
    api
      .patientNotesUpdate(id, updatedPayload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(getAllPatientNotes(pid, "", 1));
          successHandler(messages.NOTE_EDITED_SUCCESS);
        } else {
          errorHandler(res.message[0]);
        }

        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const deleteScreenshot = imgUrl => {
  return dispatch => {
    dispatch(
      deleteFileFromS3(
        {
          src: imgUrl,
        },
        () => {
          dispatch({
            type: actionTypes.DELETE_SCREENSHOT,
            payload: imgUrl,
          });
          dispatch(setCurrentNoteData({ deleteLoading: false }));
          errorHandler("Please lock note to save changes");
        },
        false
      )
    );
  };
};

export const emptyPatientData = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.EMPTY_PATIENT_DATA,
    });
  };
};

export const emptyPatientFiles = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.EMPTY_PATIENT_FILES,
    });
  };
};

export const setCurrentNoteImages = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.SET_CURRENT_NOTE_IMAGES,
      payload: getUrls(payload),
    });
  };
};

export const createPatientNote = pid => {
  return (dispatch, getState) => {
    const payload = getState()?.dashboard?.patients?.currentData;
    const updatedPayload = {
      ...payload,
      patient: pid,
    };

    dispatch(apiStart());
    api
      .patientNoteAdd(updatedPayload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(getAllPatientNotes(pid, "", 1));
          successHandler(res.message[0]);
        } else {
          errorHandler(res.message[0]);
        }

        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const searchPatientFiles = q => {
  return (dispatch, getState) => {
    const files = getState()?.dashboard?.patients?.allFiles;

    if (files?.length > 0) {
      const searchFiles = files.filter(x => {
        const fileName = x?.file_url
          ?.split("/")
          ?.pop()
          ?.split("_")
          .slice(1)
          .join("_");

        return (
          fileName?.toLowerCase()?.includes(q.toLowerCase()) ||
          (x?.record_type === "ATTACHMENT" &&
            (x.first_name?.toLowerCase()?.includes(q?.toLowerCase()) ||
              x.last_name?.toLowerCase()?.includes(q?.toLowerCase())))
        );
      });

      dispatch({
        type: actionTypes.SEARCH_PATIENT_FILES,
        searchValue: q,
        search: searchFiles,
        total_pages: 1,
      });
    }
  };
};

export const getPatientFiles = (searchValue = "", page = 1) => {
  return (dispatch, getState) => {
    dispatch(apiStart());
    let patientFiles = getState()?.dashboard?.patients?.allFiles;

    const payload = {
      patient_id: getState()?.dashboard?.patients?.patient?.id,
    };

    api
      .getPatientFiles(searchValue, page, payload)
      .then(response => {
        const res = response.data;

        if (res.status_code === 200) {
          const data =
            page > 1
              ? [...patientFiles, ...res.data[0]?.results]
              : res.data[0]?.results;
          dispatch(
            setPatientFiles({
              allFiles: data,
              total_pages: res.data[0]?.links.total_pages,
            })
          );
        } else {
          errorHandler(res.message[0]);
        }

        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const addPatientChatAttachment = file => {
  return (dispatch, getState) => {
    const visitNow = getState()?.dashboard?.ongoingAppointment?.visitNow;

    const payload = {
      appointment:
        getState()?.dashboard?.appointments?.schAppointmentDetail?.id ||
        visitNow?.appointment,
      attachment_url: file,
      visit_now: visitNow?.id,
    };

    api
      .addPatientChatAttachment(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
        } else {
          errorHandler(res.message[0]);
        }
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};
